// src/neuronest/Header.js
import React from 'react';

const DemoHeader = () => (
    <header className="bg-indigo-600 text-white py-4 px-6 text-center">
        <h1 className="text-xl font-semibold">NeuroNest 🧠✨</h1>
        <p className="text-sm">Your ADHD-friendly Productivity Companion</p>
    </header>
);

export default DemoHeader;
